export enum ClosetDoorsStandardStep {
  Environment = 1,
  DoorConfiguration = 2,
  Range = 3,
  Finishes = 4,
  Summary = 5,
}
